import React from "react";
// import { siteConfig, siteTheme } from "../../../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../stores/actionsList';
// import { nanoid } from "nanoid";
// import { socket } from "../../../utils/socket.services";
// import Loader from 'react-loader-spinner'
import { checkTranslation, imageAddress, translate } from "../../../utils/useful";
// import moment from 'jalali-moment'
// import HttpServices from "../../../utils/Http.services";
// import FormViewer from "../../FormViewer";
import Cookies from 'universal-cookie';
// import MessageBox from "../../boxes/MessageBox";
// import { getBoundingClientRect } from "../../../utils/functions";
const cookies = new Cookies();


class MessengerView extends React.Component {

    state = {

        attachmentsList: [
            { name: '{{lang}}messenger.Yonnect drive', icon: '/assets/icons/messenger/folder-a-gray.svg', function: 'attachDrive' },
            { name: '{{lang}}messenger.Album', icon: '/assets/icons/messenger/photo-a-gray.svg', function: 'attachAlbum' },
            { name: '{{lang}}messenger.File', icon: '/assets/icons/messenger/doc-a-gray.svg', function: "attachFile" },
            { name: '{{lang}}messenger.Location', icon: '/assets/icons/messenger/location-a-gray.svg', function: 'doNothing' },
            // { name: 'Camera', icon: '/assets/icons/messenger/camera.svg', function: 'doNothing' },
            // { name: 'Command', icon: '/assets/icons/messenger/command.svg', function: 'doNothing' },
            // { name: 'Contact', icon: '/assets/icons/useful/save.svg', function: 'doNothing' },
            // { name: 'Form', icon: '/assets/icons/useful/save.svg', function: 'doNothing' },
            // { name: 'Drive', icon: '/assets/icons/useful/save.svg', function: 'doNothing' },
            // { name: 'Task', icon: '/assets/icons/useful/save.svg', function: 'doNothing' },
            // { name: 'Reminder', icon: '/assets/icons/useful/reminder.svg', function: 'doNothing' },
            // { name: 'Calendar', icon: '/assets/icons/useful/save.svg', function: 'doNothing' },
            // { name: 'Room', icon: '/assets/icons/useful/save.svg', function: 'doNothing' },
            // { name: 'Format', icon: '/assets/icons/useful/save.svg', function: 'doNothing' },
            // { name: 'Products', icon: '/assets/icons/useful/save.svg', function: 'doNothing' },
            // { name: 'Applets', icon: '/assets/icons/useful/save.svg', function: 'doNothing' },


        ],
        searchValue: '',

    }

    componentDidMount() {


    }

    handleSearchInputChange = (event) => {
        this.setState({ searchValue: event.target.value });
    }

    componentWillUnmount() {
        window.removeEventListener('mousedown', this.checkOusideClicked, true)
    }

    checkOusideClicked = (e) => {
        if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
            this.forceHide()

        }
    }

    forceHide = () => {
        setTimeout(() => {
            this.showAttachments(false)
        }, 20);
        window.removeEventListener('mousedown', this.checkOusideClicked, true)

    }


    showAttachments = (status) => {
        let newStatus = status == null ? !this.state.showAttachments : status
        this.setState({ showAttachments: newStatus })

        if (newStatus) {
            window.addEventListener('mousedown', this.checkOusideClicked, true)
        }
    }

    doFunction = (prop) => {
        if (prop.function) {
            this[prop.function]()
        }
    }

    doNothing = () => {
        this.forceHide()
    }

    attachAlbum = () => {
        this.setState({ fileLimit: 'image/*,video/*' }, () => {
            this.uploadInput.click()
        })
    }

    attachFile = () => {
        this.setState({ fileLimit: null }, () => {
            this.uploadInput.click()
        })
    }

    attachFiles = (files) => {
        console.log("files")
        console.log(files)
        let final = []
        if (files) {
            Object.values(files).map((prop, index) => {
                final.push(prop)
            })
        }

        console.log(final)
        let withCompression = this.state.fileLimit == null ? false : true
        this.props.passAttachFiles(final, withCompression)
        this.forceHide()
    }


    render() {
        const filteredAttachments = this.state.attachmentsList.filter((attachment) => {
            const attachmentName = translate(attachment.name);
            return attachmentName.toLowerCase().includes(this.state.searchValue.toLowerCase());
        });
        if (this.state.showAttachments) {
            return (
                <div ref={el => this.wrapperRef = el} className="position-absolute d-flex flex-column shadow-3" style={this.props.language == 'fa' ? { right: 40, bottom: 55, borderRadius: 10, backgroundColor: '#fff' } : { left: 40, bottom: 55, borderRadius: 10, backgroundColor: '#fff' }}>
                    <div className="w-100">
                        <div className="mt-2 mx-2 top-0" style={{ zIndex: "3" }}>
                            <div className="" style={{ backgroundColor: '#f6f6f6', borderRadius: 6 }}>
                                <input className="py-2 px-2 w-100" placeholder={translate('messenger.Search')} value={this.state.searchValue} onChange={this.handleSearchInputChange} style={{ backgroundColor: 'transparent', border: 'none' }} />
                            </div>
                        </div>

                        <div className="d-flex flex-column w-100" style={{ maxHeight: 200, width: "250px" }}>
                            {filteredAttachments.map((prop, index) => {
                                return (
                                    <button style={{ zIndex: "1" }} className=" bb-gray py-1 mx-2" key={index} onClick={() => { this.doFunction(prop) }}>
                                        <div className="flexcb w-100 hover-gray py-2 px-2 br-5">
                                            <p className="main-c7" >{checkTranslation(prop.name)}</p>
                                            <img width={20} className="" src={prop.icon} />
                                        </div>
                                    </button>
                                )
                            })}
                        </div>
                    </div>

                    <div className="d-none">
                        <input
                            id="upload-input"
                            ref={el => this.uploadInput = el}
                            type="file"
                            multiple={true}
                            accept={this.state.fileLimit}
                            onChange={(e) => { this.attachFiles(e.target.files) }}
                        />
                    </div>
                </div>

            )
        } else {
            return (<></>)
        }
    }

}



const mapStateToProps = state => ({ settings: state.settings, user: state.user, messengers: state.messengers })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })


export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(MessengerView);
